import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=94e03808&scoped=true&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=94e03808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e03808",
  null
  
)

export default component.exports